import { WALLET } from '@blink/components/src/types';
import { EthereumWallet } from '@blink/components/src/utils';
import {
    EIP6963AnnounceProviderEvent,
    EIP6963ProviderDetail,
    EIP1193Provider,
} from '@blink/components/src/utils/wallet/types';

import { getWalletMap } from '@/shared/utils/getWalletMap';
let providers: EIP6963ProviderDetail[] = [];

class EIP6963Wallet extends EthereumWallet {
    constructor(private provider: EIP1193Provider) {
        super();
    }

    public isWalletInProvider(): boolean {
        return true;
    }

    public async getProvider(): Promise<any> {
        return this.provider;
    }

    public isAvailable(): boolean {
        return true;
    }
}

export const walletStore = {
    value: () => providers,

    subscribe: (
        callback: () => void,
        dispatchAccountChange: (providerName: WALLET, wallets: string[]) => void,
        dispatchNetworkChange: (chainId: string) => void,
    ) => {
        function onAnnouncement(event: EIP6963AnnounceProviderEvent) {
            const walletMap = getWalletMap();
            walletMap.set(event.detail.info.name as any, new EIP6963Wallet(event.detail.provider));
            providers = [...providers, event.detail];
            callback();

            event.detail.provider.on('accountsChanged', (wallets) =>
                dispatchAccountChange(event.detail.info.name as WALLET, wallets),
            );

            event.detail.provider.on('chainChanged', (chainId) => {
                dispatchNetworkChange(chainId);
            });
        }
        window.addEventListener(
            'eip6963:announceProvider',
            onAnnouncement as unknown as EventListener,
        );
        window.dispatchEvent(new Event('eip6963:requestProvider'));

        return () => {
            window.removeEventListener(
                'eip6963:announceProvider',
                onAnnouncement as unknown as EventListener,
            );
        };
    },
};
